/**
 * PlatformAdminBadge: a small tag rendered when a user passes the
 * Platform-Admin gate (Org == iuvo Platform AND Role == GlobalAdmin).
 * Presentational only.
 *
 * A default Carbon tag (neutral, no hue): the column or field it sits in
 * already names the concept, so the tag only says "Platform".
 */
import { Tag } from '@/components/carbon/Tag'

interface Props {
  isPlatformAdmin: boolean
}

export default function PlatformAdminBadge({ isPlatformAdmin }: Props) {
  if (!isPlatformAdmin) return null

  return (
    <Tag size="sm" title="Platform admin: sees and manages every customer tenant.">
      Platform
    </Tag>
  )
}
